import React, { useEffect } from 'react';
import { BackgroundIcon, EventEmitterWithIndex } from '@nile/components';
import envConfig from '@nile/home/src/Config/env';
import { Avatar } from '@superops/ui-design-system';
import { FormattedMessage } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { TitleHolder } from '@nile/mangifera/src/StyledComponents/KanbanBoardStyles';
import styled from 'styled-components';

const PinIconWrapper = styled.div.attrs((props) => ({
  className: `column-pin ${props.pinnedColumn ? 'pinned' : ''}`
}))``;

function LaneHeader(props) {
  const {
    name,
    list,
    actions,
    activeTab,
    pinnedColumn,
    refetchList,
    updateList
  } = props;
  const { id, title, count } = list;
  const flags = useFlags();
  const { removeFromList, togglePinnedColumn } = actions;
  // const [poperActive, setPoperActive] = useState(false);
  const isTechnician = activeTab === 'technician';
  const isUnassigned = id === 'Unassigned tickets';

  const updateLane = (params) => {
    const lanes = params?.lanes || [];
    const callback = params?.callback;
    const shouldRefreshLane = params?.lanes?.find(
      (lane) =>
        lane === list?.id || lane === list?.laneId || lane === list?.title
    );
    if (shouldRefreshLane) {
      updateList(callback);
    }
  };

  useEffect(() => {
    const eventIndex = EventEmitterWithIndex.subscribe(
      'refreshLanes',
      updateLane
    );
    return function cleanup() {
      EventEmitterWithIndex.unsubscribe('refreshLanes', eventIndex);
    };
  }, []);

  // const handleRightClick = (e) => {
  //   e.preventDefault();
  //   setPoperActive(true);
  // };
  return (
    // <Popover
    //   active={poperActive}
    //   activator={
    <TitleHolder>
      {/* onContextMenu={handleRightClick} */}
      <div className="flex center title">
        <PinIconWrapper
          onClick={() => !isUnassigned && togglePinnedColumn(list)}
          pinnedColumn={pinnedColumn}
        >
          {pinnedColumn ? (
            <SVGIcon name="Pinned" size="sm" />
          ) : (
            <SVGIcon name="PinnedWire" size="sm" color="#323232" />
          )}
        </PinIconWrapper>
        {isTechnician &&
          (!isUnassigned ? (
            <Avatar name={title} initials={title[0]} size="extraSmall" />
          ) : (
            <BackgroundIcon
              url={`url(${envConfig.imageRoot}svg/unassigned.svg)`}
              height="25px"
              width="25px"
              className="mw-25"
            />
          ))}
        <div className="ellipsis ml-10">
          {isUnassigned ? (
            <FormattedMessage id={title} />
          ) : (
            <span className={!isTechnician && 'uppercase'}>{title}</span>
          )}
        </div>
        <div className="ml-10 count">{`${count || '0'}`}</div>
      </div>
      {!pinnedColumn && (
        <span className="ptr" onClick={() => removeFromList(list)}>
          <SVGIcon name="ArrowDown" />
        </span>
      )}
    </TitleHolder>
    //   }
    //   preferredAlignment="center"
    // >
    //   <div className="p5 ptr" onClick={() => pinColumn(list.id)}>
    //     Pin Column
    //   </div>
    //   <div className="p5 mt-8 ptr" onClick={() => removeFromList(list)}>
    //     Collapse column
    //   </div>
    // </Popover>
  );
}
export default LaneHeader;
